// extracted by css-extract-rspack-plugin
export default {"root":"root-D3qd9q","article":"article-kRZ83S"};